import { render } from "./ArrowIcon.vue?vue&type=template&id=740dbcac&scoped=true&ts=true"
import script from "./ArrowIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowIcon.vue?vue&type=script&lang=ts"

import "./ArrowIcon.vue?vue&type=style&index=0&id=740dbcac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740dbcac"]])

export default __exports__